import React from 'react'
import { RiWhatsappFill } from 'react-icons/ri'


const AgentCard = ({ property }) => {
    return (
        <div className='w-full border-[1px] p-2 border-secondary rounded-md'>
            <div className='flex items-center' title="Mobile and Whatsapp">
                <p className='font-semibold text-maincolor mr-2'>Call us now!</p>
                <RiWhatsappFill
                    color={'#25D366'}
                    size={18}
                />
            </div>
            <p className='text-secondary'>{property.agent.agentName}: {property.agent.agentContact}</p>
            <p className='text-secondary sm:hidden block'>Property ID: {property.id}</p>
            <p className='font-semibold text-maincolor '>Office Hours:</p>
            <p className='text-secondary'>Mon-Fri 9am-6pm</p>
        </div>
    )
}

export default AgentCard